import React from 'react';

const DuoRomanaExtras = ({ extras, currencySymbol }) => {
  return (
    <>
      {extras?.map((e, i) => (
        <React.Fragment key={i}>
          <div>
            <p>{e.base}</p>
          </div>
          {e?.includedToppings?.map((it, j) => (
            <div
              key={j}
              className="is-flex is-justify-content-space-between-mobile is-justify-content-flex-start-tablet basket-card-extra"
            >
              <p>- {it.name}</p>
            </div>
          ))}
          {e?.excludedToppings?.map((et, v) => (
            <div
              key={v}
              className="is-flex is-justify-content-space-between-mobile is-justify-content-flex-start-tablet basket-card-extra"
            >
              <p>+ {et.name}</p>
              {et.cost > 0 ? (
                <p className="price">{`${currencySymbol}${et.cost.toFixed(
                  2
                )}`}</p>
              ) : null}
            </div>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};
export default DuoRomanaExtras;
